// extracted by mini-css-extract-plugin
export default {"container":"QrModalBody_container__k7wae","imageSection":"QrModalBody_imageSection__Ig-kL"};